import { Alert, Grid, Snackbar } from '@mui/material';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import RotatingLoader from '../common/ui/RotatingLoader';

import { TabsPage } from '../common/components/TabsPage';
import { useGetAccountAuthenticated } from '../session/swr/useGetAccountAuthenticated';
import { AccountSyncSettings } from './AccountSyncSettings';
// TODO: needs rework
// import { AccountIntegrationsSettings } from './AccountIntegrationsSettings';
import { AccountLocationsSettings } from './accountLocationsSettings/AccountLocationsSettings';
import { AccountGeneralSettings } from './AccountGeneralSettings';
import { OrderCompletionPageSettings } from './OrderCompletionPageSettings';
import { AccountSharedResourcesSettings } from './AccountSharedResourcesSettings';
import { CalendarDisplaySettings } from './CalendarDisplaySettings';
import { AccountPassSettings } from './AccountPassSettings';
import { OtherPaymentMethodsSettings } from './OtherPaymentMethodsSettings';
import { ReschedulePolicySettings } from './ReschedulePolicySettings';
import { RefundReasonsSettings } from './RefundReasonsSettings';
import { AccountVoucherSettings } from './AccountVoucherSettings';
import { ExtensionSettings } from './extensionSettings/ExtensionSettings';

enum AccountSettingsTabs {
  SYNC = 'sync',
  // TODO: needs rework
  // INTEGRATIONS = 'integrations',
  LOCATIONS = 'locations',
  GENERAL = 'general',
  PAYMENT_METHODS = 'paymentmethods',
  RESCHEDULE_POLICY = 'reschedulepolicy',
  REFUNDS = 'refunds',
  CALENDAR_DISPLAY = 'calendardisplay',
  ORDER_COMPLETE_PAGE = 'ordercompletepage',
  SHARED_RESOURCES = 'sharedresources',
  PASSES = 'passes',
  VOUCHERS = 'vouchers',
  EXTENSION = 'extension',
}

export const AccountSettingsPage = () => {
  const { t } = useTranslation();
  const { account, isLoading, updateLocalAccount } = useGetAccountAuthenticated({});
  const [isUpdatedSnackOpen, setIsUpdatedSnackOpen] = useState(false);

  if (isLoading) {
    return (
      <Grid
        container
        sx={{
          minHeight: '200px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <RotatingLoader />
      </Grid>
    );
  }

  const tabContent = {
    [AccountSettingsTabs.SYNC]: (
      <AccountSyncSettings
        account={account}
        updateLocalAccount={updateLocalAccount}
        setIsUpdatedSnackOpen={setIsUpdatedSnackOpen}
      />
    ),
    // TODO: needs rework
    // [AccountSettingsTabs.INTEGRATIONS]: (
    //   <AccountIntegrationsSettings
    //     account={account}
    //     updateLocalAccount={updateLocalAccount}
    //     setIsUpdatedSnackOpen={setIsUpdatedSnackOpen}
    //   />
    // ),
    [AccountSettingsTabs.LOCATIONS]: (
      <AccountLocationsSettings
        account={account}
        updateLocalAccount={updateLocalAccount}
        setIsUpdatedSnackOpen={setIsUpdatedSnackOpen}
      />
    ),
    [AccountSettingsTabs.ORDER_COMPLETE_PAGE]: (
      <OrderCompletionPageSettings
        account={account}
        updateLocalAccount={updateLocalAccount}
        setIsUpdatedSnackOpen={setIsUpdatedSnackOpen}
      />
    ),
    [AccountSettingsTabs.GENERAL]: (
      <AccountGeneralSettings
        account={account}
        updateLocalAccount={updateLocalAccount}
        setIsUpdatedSnackOpen={setIsUpdatedSnackOpen}
      />
    ),
    [AccountSettingsTabs.PAYMENT_METHODS]: (
      <OtherPaymentMethodsSettings
        account={account}
        updateLocalAccount={updateLocalAccount}
        setIsUpdatedSnackOpen={setIsUpdatedSnackOpen}
      />
    ),
    [AccountSettingsTabs.RESCHEDULE_POLICY]: (
      <ReschedulePolicySettings
        account={account}
        updateLocalAccount={updateLocalAccount}
        setIsUpdatedSnackOpen={setIsUpdatedSnackOpen}
      />
    ),
    [AccountSettingsTabs.REFUNDS]: (
      <RefundReasonsSettings
        account={account}
        updateLocalAccount={updateLocalAccount}
        setIsUpdatedSnackOpen={setIsUpdatedSnackOpen}
      />
    ),
    [AccountSettingsTabs.CALENDAR_DISPLAY]: (
      <CalendarDisplaySettings
        account={account}
        updateLocalAccount={updateLocalAccount}
        setIsUpdatedSnackOpen={setIsUpdatedSnackOpen}
      />
    ),
    [AccountSettingsTabs.SHARED_RESOURCES]: (
      <AccountSharedResourcesSettings
        account={account}
        updateLocalAccount={updateLocalAccount}
        setIsUpdatedSnackOpen={setIsUpdatedSnackOpen}
      />
    ),
    [AccountSettingsTabs.PASSES]: (
      <AccountPassSettings
        account={account}
        updateLocalAccount={updateLocalAccount}
        setIsUpdatedSnackOpen={setIsUpdatedSnackOpen}
      />
    ),
    [AccountSettingsTabs.VOUCHERS]: (
      <AccountVoucherSettings
        account={account}
        updateLocalAccount={updateLocalAccount}
        setIsUpdatedSnackOpen={setIsUpdatedSnackOpen}
      />
    ),
    [AccountSettingsTabs.EXTENSION]: (
      <ExtensionSettings
        account={account}
        updateLocalAccount={updateLocalAccount}
        setIsUpdatedSnackOpen={setIsUpdatedSnackOpen}
      />
    ),
  };

  return (
    <Grid container flexDirection="column" height="100%" flexWrap="nowrap" sx={{ minHeight: 0 }}>
      <Snackbar
        open={isUpdatedSnackOpen}
        onClose={() => setIsUpdatedSnackOpen(false)}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert sx={{ width: '100%' }} onClose={() => setIsUpdatedSnackOpen(false)} severity="success" variant="filled">
          {t('editOrderPage.orderPageTypeSuccess')}
        </Alert>
      </Snackbar>
      <TabsPage tabContent={tabContent} />
    </Grid>
  );
};
